import { render, staticRenderFns } from "./InspectionStatus.vue?vue&type=template&id=d482b540&scoped=true"
import script from "./InspectionStatus.vue?vue&type=script&lang=js"
export * from "./InspectionStatus.vue?vue&type=script&lang=js"
import style0 from "./InspectionStatus.vue?vue&type=style&index=0&id=d482b540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d482b540",
  null
  
)

export default component.exports